var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getLinkApiTemplateWithActions } from '../../LinkApiRouter/utils/link-api-response';
import { mapCamelKeysToSnakeKeysRecursively, mapSnakeKeysToCamelKeysRecursively, } from '../../utils/case-conversion';
import sleep from '../../utils/sleep';
import getFetch from '../../LinkApiRouter/utils/isofetch';
import { getLinkApiUrl } from '../../LinkApiRouter/utils/link-api-requests';
import { LINK_API_POLLING_INTERVAL } from '../../consts/polling';
import { formatLinkApiResponse } from '../../utils/link-api';
import { isObjEqual } from '../../utils/object';
import { setCurrentJob } from '../../tracking/datadog';
var singleton = {
    client: null,
};
// UTILS
var objToQueryParams = function (obj) {
    if (obj === void 0) { obj = {}; }
    var queryParams = Object.entries(obj);
    if (queryParams.length < 1)
        return '';
    return "?".concat(queryParams.map(function (_a) {
        var k = _a[0], v = _a[1];
        return "".concat(k, "=").concat(v);
    }).join('&'));
};
var EventListener = /** @class */ (function () {
    function EventListener() {
        this.map = { response: [], request: [] };
    }
    EventListener.prototype.on = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var event = args[0], cb = args[1];
        if (event === 'response')
            this.map.response.push(cb);
        else
            this.map.request.push(cb);
    };
    return EventListener;
}());
export var linkApiEventListener = new EventListener();
// CLIENT CREATION
export function initializeClient(linkToken, uniqueUserId, options) {
    var _this = this;
    var headers = __assign(__assign({}, options === null || options === void 0 ? void 0 : options.__headers), { 'Content-Type': 'application/json', 'Pinwheel-Link-Token': linkToken, unique_user_id: uniqueUserId });
    var lastLinkApiResponse = null;
    // Slightly verbose, but the purpose of this is essentially to check for
    // responses that are NOT of type `LinkApiResponse`. This is needed because
    // union type narrowing in TS is flimsy with `('field' in response)`, and
    // we don't want to accidentally skip the event propagation of a response
    // due to it sharing a common field name.
    var shouldSkipResponseEventPropagation = function (response) {
        return !!(('platform' in response ||
            'preSignedUrl' in response ||
            'count' in response ||
            'indexOffset' in response) &&
            // This line has no functional effect during runtime, and is solely used
            // as a compile-time check. This ensures that no types besides the ones
            // specified below can be possible here. For example, this would catch if
            // a new field `platform` ever got added to the `ResponseSuccess` type.
            (response));
    };
    function makeRequest(path, method, opts) {
        if (opts === void 0) { opts = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var body, queryParams, qpString, uri, result, rawResult, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = opts.body, queryParams = opts.queryParams;
                        qpString = objToQueryParams(queryParams);
                        uri = getLinkApiUrl(path) + qpString;
                        if (path !== 'step_result') {
                            linkApiEventListener.map.request.forEach(function (cb) {
                                return cb({ uri: uri, queryParams: queryParams, body: body });
                            });
                        }
                        return [4 /*yield*/, getFetch()(uri, {
                                method: method,
                                headers: headers,
                                body: JSON.stringify(mapCamelKeysToSnakeKeysRecursively(body)),
                            })];
                    case 1:
                        result = _a.sent();
                        if (!(result.status === 429)) return [3 /*break*/, 3];
                        // Rate limit window for initialization context is 10 seconds
                        return [4 /*yield*/, sleep(5)];
                    case 2:
                        // Rate limit window for initialization context is 10 seconds
                        _a.sent();
                        return [2 /*return*/, makeRequest(path, method, opts)];
                    case 3:
                        if (result.status === 204) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, result.json()];
                    case 4:
                        rawResult = _a.sent();
                        response = formatLinkApiResponse(rawResult);
                        if (!shouldSkipResponseEventPropagation(response)) {
                            lastLinkApiResponse = response;
                            linkApiEventListener.map.response.forEach(function (cb) { return cb(response); });
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    }
    var newClient = {
        getInitializationContext: function (idObject) {
            return makeRequest('initialization_context', 'GET', {
                queryParams: 'employerId' in idObject
                    ? { employer_id: idObject.employerId }
                    : 'platformId' in idObject
                        ? { platform_id: idObject.platformId }
                        : { platform_key: idObject.platformKey },
            });
        },
        initializeLogin: function (idObject) {
            setCurrentJob('login');
            lastLinkApiResponse = null;
            return makeRequest('initialize', 'POST', {
                body: __assign({ job: 'login' }, idObject),
            });
        },
        initializeDD: function (amountSelection, bankInfo, maskedAccountId) {
            setCurrentJob('direct_deposit_switch');
            lastLinkApiResponse = null;
            return makeRequest('initialize', 'POST', {
                body: __assign(__assign({ job: 'direct_deposit_switch' }, amountSelection), { bankInfo: bankInfo, bankInfoId: maskedAccountId }),
            });
        },
        getAppClipEvents: function (lastEventIndex) { return __awaiter(_this, void 0, void 0, function () {
            var result, rawResult, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFetch()("".concat(getLinkApiUrl('app_clip/events'), "?last_event_index=").concat(lastEventIndex), {
                            method: 'GET',
                            headers: headers,
                        })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, result.json()];
                    case 2:
                        rawResult = _a.sent();
                        response = formatLinkApiResponse(rawResult);
                        return [2 /*return*/, response];
                }
            });
        }); },
        postAppClipEvent: function (event) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, makeRequest('app_clip/events', 'POST', {
                            body: { event: event },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        acceptTerms: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, makeRequest('accept_terms', 'POST', {})];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        postUserAuthenticationFields: function (_a) {
            var social_security_number_last_four = _a.social_security_number_last_four, date_of_birth = _a.date_of_birth, mobile_phone_number = _a.mobile_phone_number;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, makeRequest('user_authentication_data', 'POST', {
                            body: {
                                social_security_number_last_four: social_security_number_last_four !== null && social_security_number_last_four !== void 0 ? social_security_number_last_four : undefined,
                                date_of_birth: date_of_birth !== null && date_of_birth !== void 0 ? date_of_birth : undefined,
                                mobile_phone_number: mobile_phone_number !== null && mobile_phone_number !== void 0 ? mobile_phone_number : undefined,
                            },
                        })];
                });
            });
        },
        postEligibilityCheck: function () { return __awaiter(_this, void 0, void 0, function () {
            var result, rawResult, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(process.env.IS_CI && process.env.ENV === 'staging')) return [3 /*break*/, 2];
                        return [4 /*yield*/, sleep(1)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, getFetch()(getLinkApiUrl('platform_matching'), {
                            method: 'POST',
                            headers: headers,
                        })];
                    case 3:
                        result = _a.sent();
                        return [4 /*yield*/, result.json()];
                    case 4:
                        rawResult = _a.sent();
                        response = formatLinkApiResponse(rawResult);
                        return [2 /*return*/, response];
                }
            });
        }); },
        getEligibilityCheck: function () { return __awaiter(_this, void 0, void 0, function () {
            var result, rawResult, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFetch()(getLinkApiUrl('platform_matching'), {
                            method: 'GET',
                            headers: headers,
                        })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, result.json()];
                    case 2:
                        rawResult = _a.sent();
                        response = formatLinkApiResponse(rawResult);
                        return [2 /*return*/, __assign(__assign({}, response), { matchedPlatforms: response.matchedPlatforms })];
                }
            });
        }); },
        getSessionStatus: function () { return __awaiter(_this, void 0, void 0, function () {
            var result, rawResult, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFetch()(getLinkApiUrl('session_status'), {
                            method: 'GET',
                            headers: headers,
                        })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, result.json()];
                    case 2:
                        rawResult = _a.sent();
                        response = formatLinkApiResponse(rawResult);
                        return [2 /*return*/, response];
                }
            });
        }); },
        submitStep: function (stepInput, encryptionInfo) { return __awaiter(_this, void 0, void 0, function () {
            var template, isStepInputAnAction, payload, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        template = getLinkApiTemplateWithActions(lastLinkApiResponse);
                        isStepInputAnAction = template &&
                            'actions' in template &&
                            template.actions.some(function (action) {
                                return isObjEqual('payload' in action ? action.payload : null, stepInput);
                            });
                        payload = isStepInputAnAction
                            ? stepInput
                            : mapCamelKeysToSnakeKeysRecursively(stepInput);
                        return [4 /*yield*/, makeRequest('next', 'POST', {
                                body: { payload: payload, encryptionInfo: encryptionInfo },
                            })];
                    case 1:
                        response = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(response.responseType === 'processing' && !response.title)) return [3 /*break*/, 5];
                        return [4 /*yield*/, sleep(LINK_API_POLLING_INTERVAL)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, makeRequest('step_result', 'GET')];
                    case 4:
                        response = _a.sent();
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, response];
                }
            });
        }); },
        waitForStepResult: function () { return __awaiter(_this, void 0, void 0, function () {
            var originalResponseTitle, originalResponseSubtitle, shouldRepoll;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (lastLinkApiResponse.responseType !== 'processing')
                            return [2 /*return*/, lastLinkApiResponse];
                        originalResponseTitle = lastLinkApiResponse.title;
                        originalResponseSubtitle = lastLinkApiResponse.subtitle;
                        shouldRepoll = function () {
                            return lastLinkApiResponse.responseType === 'processing' &&
                                lastLinkApiResponse.title === originalResponseTitle &&
                                lastLinkApiResponse.subtitle === originalResponseSubtitle;
                        };
                        _a.label = 1;
                    case 1:
                        if (!shouldRepoll()) return [3 /*break*/, 5];
                        return [4 /*yield*/, makeRequest('step_result', 'GET')];
                    case 2:
                        _a.sent();
                        if (!shouldRepoll()) return [3 /*break*/, 4];
                        return [4 /*yield*/, sleep(LINK_API_POLLING_INTERVAL)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 1];
                    case 5: return [2 /*return*/, lastLinkApiResponse];
                }
            });
        }); },
        fetchAccountInformation: function () { return __awaiter(_this, void 0, void 0, function () {
            var uri, result, rawResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lastLinkApiResponse = null;
                        uri = getLinkApiUrl('account');
                        return [4 /*yield*/, getFetch()(uri, {
                                method: 'GET',
                                headers: headers,
                            })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, result.json()];
                    case 2:
                        rawResult = _a.sent();
                        return [2 /*return*/, mapSnakeKeysToCamelKeysRecursively(rawResult)];
                }
            });
        }); },
        initializeCardSwitch: function () {
            setCurrentJob('card_switch');
            lastLinkApiResponse = null;
            return makeRequest('initialize', 'POST', {
                body: { job: 'card_switch' },
            });
        },
        initializeBillSwitch: function () {
            setCurrentJob('bill_switch');
            lastLinkApiResponse = null;
            return makeRequest('initialize', 'POST', {
                body: { job: 'bill_switch' },
            });
        },
        initializeBillCancellation: function () {
            setCurrentJob('bill_cancellation');
            lastLinkApiResponse = null;
            return makeRequest('initialize', 'POST', {
                body: { job: 'bill_cancellation' },
            });
        },
        fetchPreSignedUrl: function (documentUploadsType, fileName) {
            return makeRequest('documents/generate_url', 'POST', {
                body: {
                    document_type: documentUploadsType,
                    file_name: fileName,
                },
            });
        },
        submitDocuments: function (preSignedUrls) {
            return makeRequest('documents/submit', 'POST', {
                body: {
                    pre_signed_urls: preSignedUrls,
                },
            });
        },
    };
    singleton.client = newClient;
    return newClient;
}
export var resetClient = function () {
    singleton.client = null;
};
export var getClient = function () { return singleton.client; };
